import Alert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';
const StyledAlert = styled(Alert)(({ theme: { palette } }) => {
    const resolveProps = (color) => ({
        color,
        border: `1px solid ${color}`,
    });
    return {
        '&.MuiAlert-standardSuccess': resolveProps(palette.success.main),
        '&.MuiAlert-standardWarning': resolveProps(palette.warning.main),
        '&.MuiAlert-standardInfo': resolveProps(palette.info.main),
        '&.MuiAlert-standardError': resolveProps(palette.error.main),
        '& .MuiAlert-message': {
            fontWeight: 700,
        },
    };
});
export default StyledAlert;
